/**
 * Returns true when `b` is later than `a`. Null `b` never wins; null `a` always
 * loses to a non-null `b`. Used to pick the leaf with the latest
 * `complianceMonitoringAssessment.CreatedAtTimestamp` across an entity's
 * second-line results.
 */
export const isLater = (a: string | null, b: string | null): boolean => {
  if (b === null) {
    return false;
  }
  if (a === null) {
    return true;
  }

  return new Date(b).getTime() > new Date(a).getTime();
};

/**
 * The shape of the `cmaParent` selection returned by the
 * `getLatestOversight*ByXIds` family of queries — an array of at most one
 * compliance_monitoring_assessment parent, server-filtered and ordered by
 * `CreatedAtTimestamp desc_nulls_last`.
 */
export type OversightCmaParent = {
  complianceMonitoringAssessment?: {
    CreatedAtTimestamp?: string | null;
  } | null;
}[];

/**
 * Reads the `CreatedAtTimestamp` from the first (latest) CMA parent in a
 * server-ordered `cmaParent` selection. Returns null when the selection is
 * empty, missing, or the date is absent.
 */
export const extractCmaCreatedAt = (
  cmaParent: OversightCmaParent | null | undefined
): string | null =>
  cmaParent?.[0]?.complianceMonitoringAssessment?.CreatedAtTimestamp ?? null;
